export default __webpack_public_path__ + "static/media/cello.3862c0fa.jpg";